import { camelizeKeys } from 'humps'

import { LocalStorageError } from 'exceptions/localStorage'
import { isProxy } from 'config'

const EMBER_AUTH_SESSION = 'ember_simple_auth-session'

const getEmberAuthSession = () => localStorage.getItem(EMBER_AUTH_SESSION)

export const getExposedCredentials = () => {
  const token = JSON.parse(getEmberAuthSession())

  if (token === null) {
    throw new LocalStorageError("There's no session storage in local storage")
  }

  const {
    authenticator,
    accessToken,
    tokenType,
    refreshToken,
    expiresIn,
    expiresAt,
  } = camelizeKeys(token.authenticated)

  return {
    authenticator,
    accessToken,
    tokenType,
    refreshToken,
    expiresIn,
    expiresAt,
  }
}

export const isAuthorized = () => {
  if (isProxy()) {
    return true
  }
  try {
    return !!getExposedCredentials().accessToken
  } catch (e) {
    return false
  }
}

export const destroyCredentials = () => {
  if (process.env.NODE_ENV !== 'development') {
    return localStorage.removeItem(EMBER_AUTH_SESSION)
  }

  return localStorage.setItem(EMBER_AUTH_SESSION, JSON.stringify({}))
}
